<template>
  <div>
    <transition-group
      :class="['image-list-editor-125326433', 'layout', 'align-center', 'wrap']"
      tag="div"
      name="list-complete"
    >
      <v-card v-for="(image, index) in images" :key="image.id" class="no-grow mr-2 mb-2 img-set">
        <img class="img-set__img" :src="image.image.main_url">
        <template>
          <v-btn
            class="side-btn-3"
            absolute
            fab
            bottom
            right
            color="secondary"
            @click="del(image.id)"
          >
            <v-icon>delete</v-icon>
          </v-btn>
          <v-btn
            class="side-btn-2"
            absolute
            fab
            bottom
            right
            color="secondary"
            :disabled="index===0"
            @click="swap(image.id, images[index-1].id)"
          >
            <v-icon>chevron_left</v-icon>
          </v-btn>
          <v-btn
            class="side-btn-1"
            absolute
            fab
            bottom
            right
            color="secondary"
            :disabled="index===images.length-1"
            @click="swap(image.id, images[index+1].id)"
          >
            <v-icon>chevron_right</v-icon>
          </v-btn>
        </template>
      </v-card>
      <v-layout
        :key="'i am a string and as long as others keys are numbers, i am unique'"
        align-center
        wrap
        class="expanded"
      >
        <v-flex>
          <v-layout>
            <div class="plus-file md-layout-item md-gutter" md-with-hover>
              <v-btn
                small
                fab
                color="secondary"
                @click="showCropper = true"
              >
                <v-icon>add</v-icon>
              </v-btn>
            </div>
          </v-layout>
        </v-flex>
      </v-layout>
    </transition-group>
    <my-upload
      v-model="showCropper"
      noCircle
      class="settings__edit"
      :width="width"
      :height="height"
      langType="ru"
      img-format="png"
      @crop-success="cropSuccess"
    />

    <div v-if="User.isSuperAdmin()" class="divider" :style="{ background: isThemeDark ? '#303030' : '#fafafa' }" />

    <div v-if="User.isSuperAdmin()" class="captcha-block">
      <h2 class="captcha-block__title">Настройки защиты</h2>

      <div style="padding: 10px 0">
        <v-list>
          <v-list-tile v-for="item in items" :key="item.key">
            <v-list-tile-title class="font-weight-light">{{ item.title }}</v-list-tile-title>

            <v-switch
              v-model="item.status"
              class="games__show font-weight-light"
              :label="item.status ? 'Включено' : 'Отключено'"
              @change="changeGameStatus(item)"
            />
          </v-list-tile>
        </v-list>
      </div>
    </div>

    <div style="display: flex; align-items: center; max-width: 500px">
      <p style="margin: 0 15px 15px 0">Сброс попыток</p>
      <v-text-field
        v-model="resetFingerprint"
        color="accent"
        placeholder="Fingerprint или ip"
        style="margin: 0; padding: 0;"
      />
      <v-btn
        color="primary"
        :disabled="!resetFingerprint || !User.hasAdminAccess()"
        style="margin: 0 0 15px 25px"
        @click="clickOnReset"
      >
        Сбросить
      </v-btn>
    </div>

    <div v-if="User.hasAccess()" class="divider" :style="{ background: isThemeDark ? '#303030' : '#fafafa' }" />

    <div v-if="User.hasAccess()" class="email_block">
      <h2 class="email_block__title">Лимиты по почтовым доменам</h2>

      <div style="padding: 10px 0">
        <v-btn
          fab
          small
          color="secondary"
          @click="() => {
            showEmailModal = true
            editItem = null
          }"
        >
          <v-icon
            small
          >
            add
          </v-icon>
        </v-btn>

        <EmailDomainTable
          @open-edit="(item) => {
            showEmailModal = true
            editItem = item
          }"
        />
      </div>
    </div>

    <v-snackbar
      v-model="snackbar"
    >
      <p style="margin: 0 auto">{{ snackbarText }}</p>
    </v-snackbar>

    <email-domain-modal
      :value="showEmailModal"
      :item="editItem"
      @update:dialog="showEmailModal = $event"
      @show-error="(message) => {
        snackbar = true
        snackbarText = message
      }"
    />
  </div>
</template>

<script>
import myUpload from 'vue-image-crop-upload'
import EmailDomainTable from '@/components/common/Table/EmailDomainTable/EmailDomainTable.vue'
import EmailDomainModal from '@/components/modals/EmailDomainModal.vue'

import {
  deleteBanner,
  getBanners,
  createBanner,
  swapBanners,
  getCaptchaLevel,
  setCaptchaLevel,
  getRegLimits,
  setRegLimits,
  getLoginLimits,
  getHoneypot,
  setHoneypot,
  setFingerprint,
  getFingerprint, resetFingerprint, getEmailable, setEmailable, setVerification, getVerification,
  getLoginCaptchaStatus, setLoginCaptchaStatus
} from '../../api/banners'
import User from '../../helpers/user'

export default {
  components: {
    myUpload,
    EmailDomainTable,
    EmailDomainModal
  },
  data: () => ({
    isThemeDark: JSON.parse(localStorage.getItem('isThemeDark')) || false,
    images: [],
    showCropper: false,
    snackbar: false,
    editItem: null,
    showEmailModal: false,
    snackbarText: '',
    resetFingerprint: '',
    items: [
      {
        title: 'Повышенная сложность капчи',
        key: 'capt',
        status: false,
        start: () => setCaptchaLevel('high'),
        stop: () => setCaptchaLevel('low')
      },
      {
        title: 'Капча для авторизации',
        key: 'loginCaptcha',
        status: false,
        start: () => setLoginCaptchaStatus({ status: true }),
        stop: () => setLoginCaptchaStatus({ status: false })
      },
      {
        title: 'Прогрессивный рейт лимит на регистрацию',
        key: 'reg',
        status: false,
        start: null,
        stop: null
      },
      {
        title: 'Прогрессивный рейт лимит на авторизацию',
        key: 'login',
        status: false,
        start: null,
        stop: null
      },
      {
        title: 'Honeypot',
        key: 'honey',
        status: false,
        start: () => setHoneypot({ status: true }),
        stop: () => setHoneypot({ status: false })
      },
      {
        title: 'Fingerprint',
        key: 'fingerprint',
        status: false,
        start: () => setFingerprint({ state: true }),
        stop: () => setFingerprint({ state: false })
      },
      {
        title: 'Верификация почты Emailable',
        key: 'emailable',
        status: false,
        start: () => setEmailable({ state: true }),
        stop: () => setEmailable({ state: false })
      },
      {
        title: 'JaFingerprint ',
        key: 'jaFingerprint',
        status: false,
        start: null,
        stop: null
      },
      {
        title: 'Принудительная верификация фиат h2c',
        key: 'verification',
        status: false,
        start: () => setVerification({ status: true }),
        stop: () => setVerification({ status: false })
      }
    ],
    width: 560, //2560,
    height: 208//564
  }),
  computed: {
    User () {
      return User
    }
  },
  mounted () {
    EventBus.$on('theme-changed', e => (this.isThemeDark = e))
    this.getImages()
    if (this.User.isSuperAdmin()) {
      this.loadCaptchaStatus()
      this.loadRegLimit()
      this.loadLoginLimit()
      this.loadHoneypot()
      this.loadFingerprint()
      this.loadEmailable()
      this.loadVerification()
      this.loadLoginCaptchaStatus()
    }
  },
  methods: {
    async clickOnReset () {
      if (this.resetFingerprint)
        try {
          await resetFingerprint(this.resetFingerprint)
          this.snackbar = true
          this.resetFingerprint = ''
          this.snackbarText = 'Успешно'
        } catch (e) {
          this.snackbar = true
          this.snackbarText = e.response.data.message
        }
    },
    dataURLtoFile (dataurl, filename) {
      let arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n)
      while (n--)
        u8arr[n] = bstr.charCodeAt(n)

      return new File([u8arr], filename, { type: mime })
    },
    changeGameStatus (item) {
      if (item.status) item.start()
      else item.stop()
    },
    cropSuccess (imgDataUrl, field) {
      const file = this.dataURLtoFile(imgDataUrl, 'image.jpg')
      createBanner(file).then(this.getImages)
    },
    getImages () {
      getBanners().then(({ data }) => {
        this.images = data
      })
    },
    loadCaptchaStatus () {
      getCaptchaLevel().then(res => {
        this.items = this.items.map(item => {
          if (item.key === 'capt')
            return {
              ...item,
              status: res.data.level === 'high'
            }

          return item
        })
      })
        .catch(error => {
          console.log(error)
        })
    },
    loadRegLimit () {
      getRegLimits().then(res => {
        if (!res.data.length > 0) return
        const regLimit = res.data[0]
        this.items = this.items.map(item => {
          if (item.key === 'reg')
            return {
              ...item,
              status: regLimit.use_steps,
              start: () => setRegLimits(regLimit.id, {
                use_steps: true
              }),
              stop: () => setRegLimits(regLimit.id, {
                use_steps: false
              })
            }

          if (item.key === 'jaFingerprint')
            return {
              ...item,
              status: regLimit.use_ja_fingerprint,
              start: () => setRegLimits(regLimit.id, {
                use_ja_fingerprint: true
              }),
              stop: () => setRegLimits(regLimit.id, {
                use_ja_fingerprint: false
              })
            }


          return item
        })
      })
        .catch(error => {
          console.log(error)
        })
    },
    loadLoginLimit () {
      getLoginLimits().then(res => {
        if (!res.data.length > 0) return
        const loginLimit = res.data[0]
        this.items = this.items.map(item => {
          if (item.key === 'login')
            return {
              ...item,
              status: loginLimit.use_steps,
              start: () => setRegLimits(loginLimit.id, {
                use_steps: true
              }),
              stop: () => setRegLimits(loginLimit.id, {
                use_steps: false
              })
            }

          return item
        })
      })
        .catch(error => {
          console.log(error)
        })
    },
    loadHoneypot () {
      getHoneypot().then(res => {
        this.items = this.items.map(item => {
          if (item.key === 'honey')
            return {
              ...item,
              status: res.data.status
            }

          return item
        })
      })
        .catch(error => {
          console.log(error)
        })
    },
    loadFingerprint () {
      getFingerprint().then(res => {
        this.items = this.items.map(item => {
          if (item.key === 'fingerprint')
            return {
              ...item,
              status: res.data.state
            }

          return item
        })
      })
        .catch(error => {
          console.log(error)
        })
    },
    loadEmailable () {
      getEmailable().then(res => {
        this.items = this.items.map(item => {
          if (item.key === 'emailable')
            return {
              ...item,
              status: res.data.state
            }

          return item
        })
      })
        .catch(error => {
          console.log(error)
        })
    },
    loadVerification () {
      getVerification().then(res => {
        this.items = this.items.map(item => {
          if (item.key === 'verification')
            return {
              ...item,
              status: res.data.status
            }

          return item
        })
      })
        .catch(error => {
          console.log(error)
        })
    },
    loadLoginCaptchaStatus () {
      getLoginCaptchaStatus().then(res => {
        this.items = this.items.map(item => {
          if (item.key === 'loginCaptcha')
            return {
              ...item,
              status: res.data.status
            }

          return item
        })
      })
        .catch(error => {
          console.log(error)
        })
    },
    swap (firstBannerID, secondBannerID) {
      swapBanners(firstBannerID, secondBannerID).then(this.getImages)
    },
    del (bannerID) {
      deleteBanner(bannerID).then(this.getImages)
    }
  }
}
</script>

<style lang="scss" scoped>
.divider {
  width: 105%;
  height: 50px;
  margin-left: -18px;
}

.add-link-element {
  width: 100%;
  margin-bottom: 0;
  margin-left: 0;
  margin-right: 0;
}
.list-complete-item {
  transition: all 1s;
}
.list-complete-enter,
.list-complete-leave-to {
  opacity: 0;
  transform: translateY(30px);
}
.list-complete-leave-active {
  position: absolute;
}
.expanded .img-set__img {
  min-width: 140px;
  margin: 0 auto;
  display: block;
}
.img-set {
  width: fit-content;
  min-width: 200px;
  min-height: 200px;
  max-width:100%;
  max-height:400px;

  .v-card__actions {
    margin-top: -45px;
  }
  .v-card__actions .v-btn,
  .v-card__actions > * {
    background: rgba(255, 255, 255, 0.2);
  }
}

.img-set__img {
  height: auto;
  max-width: 100%;
}
.side-btn-1 {
  z-index: 1 !important;
  transform: scale(0.7) translate(-115px, 2px);
}
.side-btn-2 {
  z-index: 1 !important;
  transform: scale(0.7) translate(-52px, 2px);
}
.side-btn-3 {
  z-index: 1 !important;
  transform: scale(0.7) translate(11px, 2px);
}
.plus-file {
  flex: none;
  height: 40px;
  position: relative;
  width: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 5px;
  &__input {
    cursor: pointer;
    &::-webkit-file-upload-button {
      cursor: pointer;
    }
    opacity: 0;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
  }
}
.captcha-block, .email_block {
  margin-top: 10px;

  &__title {
    font-size: 20px;
    font-weight: 500;
  }
}
</style>
